import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import heroBg from '../assets/hero-bg.png';
import privacyPolicy from '../assets/Online-Privacy Policy-Copper Road Experiences.pdf';

export default function LandingPage() {
    const navigate = useNavigate();

    return (
        <div style={styles.container}>
            {/* Hero Section */}
            <div style={styles.hero}>
                <div style={styles.overlay} />
                <div style={styles.heroContent}>
                    <img src={logo} alt="The Copper Road" style={styles.logo} />
                    <h1 style={styles.tagline}>Every Road Leads to<br />Something Worth Tasting</h1>
                    <p style={styles.description}>
                        The Finest Bourbon and Whiskey, One Stop at a Time. Discover the heritage, 
                        the craft, and the stories behind the world's most famous copper-still spirits.
                    </p>
                    <div style={styles.ctaGroup}>
                        <button 
                            style={styles.primaryBtn} 
                            onClick={() => navigate('/login')}
                        >
                            Start Your Journey
                        </button>
                        <button 
                            style={styles.secondaryBtn} 
                            onClick={() => navigate('/register')}
                        >
                            Create Free Account
                        </button>
                    </div>
                </div>
            </div>

            {/* How it Works / About Section */}
            <div style={styles.section}>
                <h2 style={styles.sectionTitle}>The Experience</h2>
                <div style={styles.grid}>
                    <div style={styles.card}>
                        <span style={styles.cardIcon}>🗺️</span>
                        <h3>Choose Your Road</h3>
                        <p>Select from curated whiskey trails and craft brewery routes across Kentucky.</p>
                    </div>
                    <div style={styles.card}>
                        <span style={styles.cardIcon}>📷</span>
                        <h3>Check-In & Collect</h3>
                        <p>Scan QR codes at every stop to track your progress and unlock exclusive rewards.</p>
                    </div>
                    <div style={styles.card}>
                        <span style={styles.cardIcon}>🏅</span>
                        <h3>Earn Your Reward</h3>
                        <p>Complete a road to earn your official Copper Road Finisher T-shirt and digital badges.</p>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer style={styles.footer}>
                <p style={{ marginBottom: 12 }}>
                    Would you like to add your stop to the Copper Road? 
                    Email us at <a href="mailto:info@copperroadexperiences.com" style={{ color: '#B87333', textDecoration: 'none', fontWeight: 'bold' }}>info@copperroadexperiences.com</a>
                </p>
                <p>
                    &copy; 2026 The Copper Road. All rights reserved.
                    <span style={{ margin: '0 8px' }}>•</span>
                    <a href="/privacy-policy" onClick={(e) => { e.preventDefault(); navigate('/privacy-policy'); }} style={{ color: '#888', textDecoration: 'none' }}>Privacy Policy</a>
                </p>
            </footer>
        </div>
    );
}

const styles = {
    container: {
        background: '#fff',
        minHeight: '100vh',
        fontFamily: "'Inter', sans-serif",
    },
    hero: {
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `url(${heroBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        textAlign: 'center',
        color: '#fff',
        padding: '80px 20px',
    },
    overlay: {
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.4) 50%, rgba(26,34,52,0.9) 100%)',
        zIndex: 1,
    },
    heroContent: {
        position: 'relative',
        zIndex: 2,
        maxWidth: 800,
        width: '100%',
    },
    logo: {
        width: 'min(180px, 45vw)',
        height: 'auto',
        marginBottom: 32,
        marginTop: 10,
        filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.4))',
    },
    tagline: {
        fontSize: 'clamp(28px, 8vw, 64px)',
        fontFamily: "Georgia, 'Times New Roman', serif",
        fontWeight: 'bold',
        lineHeight: 1.1,
        marginBottom: 20,
        letterSpacing: '-0.02em',
        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
    },
    description: {
        fontSize: 'clamp(16px, 4vw, 20px)',
        color: 'rgba(255,255,255,0.95)',
        maxWidth: 650,
        margin: '0 auto 48px',
        lineHeight: 1.6,
        textShadow: '0 1px 2px rgba(0,0,0,0.2)',
    },
    ctaGroup: {
        display: 'flex',
        gap: 16,
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
    primaryBtn: {
        background: '#B87333',
        color: '#fff',
        border: 'none',
        padding: '16px 36px',
        borderRadius: 30,
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 10px 20px rgba(184,115,51,0.3)',
        transition: 'transform 0.2s, background 0.2s',
    },
    secondaryBtn: {
        background: '#fff',
        color: '#B87333',
        border: '2px solid #B87333',
        padding: '16px 36px',
        borderRadius: 30,
        fontSize: '16px',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
        transition: 'transform 0.2s, background 0.2s',
    },
    section: {
        background: '#fff',
        padding: '100px 20px',
        maxWidth: 1200,
        margin: '0 auto',
        textAlign: 'center',
    },
    sectionTitle: {
        fontSize: '32px',
        fontFamily: 'Georgia, serif',
        color: '#1a2234',
        marginBottom: 60,
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
        gap: 40,
    },
    card: {
        padding: 40,
        borderRadius: 24,
        background: '#fcfcfc',
        border: '1px solid #f0f0f0',
        transition: 'transform 0.3s',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    cardIcon: {
        fontSize: 40,
        marginBottom: 24,
    },
    footer: {
        padding: '40px 20px',
        textAlign: 'center',
        borderTop: '1px solid #eee',
        color: '#888',
        fontSize: '14px',
    }
};
